import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import { ESTADOS_GLOBALES_MAP } from 'utils/estadosGlobales';

export const baseURI = 'recaudacion/estados-del-credito-pae/';

/**
 * GET Estados del Credito
 * param {object} params
 * @returns {Promise<object>}
 */
export const getEstadosDelCredito = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Estado del Credito
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getEstadoDelCredito = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Estado del Credito
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postEstadoDelCredito = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Estado del Credito
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchEstadoDelCredito = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Estado del Credito
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteEstadoDelCredito = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, {
      estados_globales: ESTADOS_GLOBALES_MAP.CANCELADO,
    });
    onSuccess(response, 'Cancelado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
